export function buildPaginationQuery({
    page = 1,
    limit = 25,
    search = '',
    sortBy = '',
    sortDir = 'asc',
    extraParams = {},
} = {}) {
    const params = new URLSearchParams();

    params.set('page', String(page));
    params.set('limit', String(limit));

    if (search && search.trim() !== '') {
        params.set('search', search.trim());
    }

    if (sortBy) {
        params.set('sortBy', sortBy);
        params.set('sortDir', sortDir || 'asc');
    }

    Object.entries(extraParams || {}).forEach(([key, value]) => {
        if (value == null || value === '') {
            return;
        }
        params.set(key, String(value));
    });

    return params.toString();
}

export function getPaginatedData(responseData, fallbackItems = []) {
    if (
        responseData?.data?.pagination &&
        Array.isArray(responseData?.data?.purchasesByMonth)
    ) {
        return {
            ...responseData.data.pagination,
            items: responseData.data.purchasesByMonth,
        };
    }

    if (responseData?.data?.items && Array.isArray(responseData.data.items)) {
        return responseData.data;
    }

    const items = Array.isArray(responseData?.data) ? responseData.data : fallbackItems;
    return {
        items,
        total: items.length,
        page: 1,
        limit: items.length || 25,
        totalPages: 1,
    };
}

export function scheduleDebouncedCallback(component, key, callback, delay = 500) {
    clearDebouncedCallback(component, key);
    component[key] = setTimeout(callback, delay);
}

export function clearDebouncedCallback(component, key) {
    if (component && component[key]) {
        clearTimeout(component[key]);
        component[key] = null;
    }
}
